/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Route from '@ember/routing/route';

export default class RequestSeatRoute extends Route {
  model() {
    return this.modelFor('apps.app.seatless-experience');
  }
}
